import React, { Component } from 'react';
import { connect } from "react-redux";
import { FindOffice } from './subcomponents/FindOffice';
import { PersonalInfo } from './subcomponents/PersonalInfo';
import { personalInfoConstants } from "../_constants";
import { SlPageTitle } from './editors';

class NewLoan extends Component {
    static displayName = NewLoan.name;

    constructor(props) {
        super(props);
    }

    render() {
        const { loggedIn } = this.props;

        return (
            <div>
                <SlPageTitle pageName="Request_New" />
                {!loggedIn && (
                    <FindOffice />)}

                {/*{loggedIn && (*/}
                {/*    <PersonalInfo formState={personalInfoConstants.STATE_NEW_LOAN_LOGGED_IN} />)}*/}
            </div>
        );  
    }
}

function mapStateToProps(state) {
    const { loggedIn } = state.authentication;

    return {
        loggedIn
    };
}

const connectedNewLoan = connect(mapStateToProps)(NewLoan);
export { connectedNewLoan as NewLoan };


// WEBPACK FOOTER //
// ./src/components/NewLoan.js